import { Fragment, useState } from "react";
import { Tooltip } from "reactstrap";
import { MailHeaders } from "../../../../../data/applications/LetterBox";
import { useAppDispatch } from "../../../../../reduxToolkit/hooks";
import { handleInterview } from "../../../../../reduxToolkit/reducers/letterBoxSlice";
import { InterviewMail } from "../../../../../constants";
import SvgIcon from "../../../../../coreComponents/SvgIcon";

const MailHeader = () => {

  const dispatch = useAppDispatch();
  const [tooltipOpen, setTooltipOpen] = useState<number | null>(null);

  return (
    <div className="mail-header-wrapper header-wrapper1">
      <div className="mail-header1">
        <div className="light-square" onClick={() => dispatch(handleInterview(false))}>
          <SvgIcon className="btn-email" iconId="back-arrow" />
        </div>
        <span>{InterviewMail}</span>
      </div>
      <div className="mail-body1">
        {MailHeaders.map((data, index) => (
          <Fragment key={index}>
            <div className={data.class} id={`light-${data.icon}`}>
              <SvgIcon iconId={data.icon} className={data.className ? data.className : ""} />
            </div>
            <Tooltip placement="top" isOpen={tooltipOpen === index} target={`light-${data.icon}`} toggle={() => setTooltipOpen(tooltipOpen !== index ? index : null)}>
              {data.tooltip}
            </Tooltip>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default MailHeader;